import Icon from '../components/Icon.vue'

Icon.register({
  'paint-brush': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M167 309.3l88 73.3c0.3 3.1 1 6 1 9.1 0 76.4-52.1 120.2-128 120.2-90.1 0-128-72.4-128-154.7 9.8 6.7 44.1 34.4 55.3 34.4 6.6 0 12.2-3.8 14.6-10 20.7-54.4 57.1-69.7 97.2-72.3zM457.9 0c28.1 0 54.1 20.6 54.1 49.5 0 16.1-6.5 31.6-13.9 46-113 211-149.1 256.5-211.2 256.5-7.8 0-15.2-1.2-22.4-3l-63.8-53.2c-5.5-11.9-8.7-25-8.7-38.7 0-53.8 21.3-58 225.7-240.6 10.8-9.7 25.1-16.5 40.2-16.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/paint-brush.js
// module id = 1604
// module chunks = 0